import React from "react";
import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { PageListBean } from "../ds/client_ds.js";
import {
  AddressBean,
  RestReadRequest,
  RestShipToListRequest,
  ShipToBean,
  ShipToSearchCriteria,
} from "../ds/ds.js";
import { DropDwnDown, DropDwnUp } from "../gui_components/Icons.js";
import {
  AlertToolBox,
  InputCheckbox,
  InputTextbox,
  ShowError,
} from "../gui_components/UIComponents.js";
import { isEmpty, isEmptyArray } from "../gui_components/Util.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import {
  BaseInquiryPageListToolBar,
  BaseInquiryToolBar,
  BaseToolBar,
} from "../modules/BaseModule.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { MasterService } from "../services/MasterService.js";
class ShipToListForm extends React.Component {
  constructor(props) {
    super(props);
    this.listFormCodeRef = React.createRef();
    this.searchRef = React.createRef();
  }

  componentDidMount() { }
  componentDidUpdate() {
    this.setInputFocus();
  }
  setInputFocus() {
    if (this.listFormCodeRef.current != null) {
      this.listFormCodeRef.current.focus();
    }
  }
  enterKeyEventHandler = (e) => {
    this.props.enterKeyEventHandler(e);
  };
  onChange = (e) => {
    this.props.onChange(e);
  };
  opentypeforms = (e) => {
    if (e.detail === 1) this.props.opentypeforms();
  };
  editShipTo = (e, val) => {
    if (e.detail === 1) this.props.editShipTo(val);
  };
  handleSortingChange = (e, accessor) => {
    if (e.detail === 1) this.props.handleSortingChange(accessor);
  };

  filterOnChange = (e) => {
    this.props.filterOnChange(e);
  }
  filterShipToType = (e) => {
    if (e.detail === 1) this.props.filterShipToType(e);
  }

  resetShiptToType = (e) => {
    if (e.detail === 1) this.props.resetShiptToType(e);
  }

  render() {
    let shipTo_list = this.props.shipTo_list;
    let shipToData = this.props.shipToData;

    return (
      <div>
        <div>
          <Row>
            <Col sm="1">
              <FormLabel id="searchBarLabel">ShipTo</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                //  ref={this.listFormCodeRef}
                type="text"
                name="code"
                onChange={this.onChange}
                value={shipToData.code}
                style={{ "text-transform": "uppercase" }}
                enterKeyEventHandler={this.enterKeyEventHandler}
                isMandatory={true}
              ></InputTextbox>
            </Col>

            <Col sm="1">
              <Button
                id="fabric_Add_Button"
                className="text-center"
                onClick={(e) => this.opentypeforms(e)}
              >
                Go
              </Button>
            </Col>



            <Col sm="1">
              <FormLabel >Search</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                ref={this.searchRef}
                type="text"
                name="codeContains"
                onChange={this.filterOnChange}
                value={this.props.criteria.codeContains}
              ></InputTextbox>
            </Col>
            <Col sm="2">
              <Button
                id="fabric_Add_Button"
                className="text-center"
                onClick={(e) => this.filterShipToType(e)}
              >
                Filter
              </Button>

              <Button
                id="fabric_Add_Button"
                className="text-center"
                onClick={(e) => this.resetShiptToType(e)}
              >
                Reset
              </Button>
            </Col>

          </Row>
        </div>
        <div className="div_default">
          <Table id="fabrics_tables_default">
            <thead>
              <tr>
                <th onClick={(e) => this.handleSortingChange(e, "code")}>
                  Code{" "}
                  {this.props.order === "desc" &&
                    this.props.sortField === "code" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "description")}>
                  Name{" "}
                  {this.props.order === "desc" &&
                    this.props.sortField === "description" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "companyCode")}>
                  CompanyCode{" "}
                  {this.props.order === "desc" &&
                    this.props.sortField === "companyCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "isActive")}>
                  Active{" "}
                  {this.props.order === "desc" &&
                    this.props.sortField === "isActive" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
              </tr>
            </thead>
            <tbody>
              {shipTo_list.map((Info, index) => (
                <tr key={index}>
                  <td className="td_attribute_width">
                    <Button
                      variant="secondry"
                      className="hyperLinkText"
                      onClick={(e) => this.editShipTo(e, Info.code)}
                    >
                      {Info.code}
                    </Button>
                  </td>
                  <td> {Info.description}</td>
                  <td>{Info.companyCode}</td>
                  <td>{Info.isActive}</td>
                </tr>
              ))}
            </tbody>
          </Table>
          {shipTo_list.length != 0 ? null : (
            <div className="no_Data">{"NO DATA"}</div>
          )}
        </div>
      </div>
    );
  }
}

class ShipToEntryForm extends React.Component {
  constructor(props) {
    super(props);
    this.codeRef = React.createRef();
  }

  componentDidMount() {
    this.setInputFocus();
  }
  setInputFocus() {
    if (this.codeRef.current != null) {
      this.codeRef.current.focus();
    }
  }
  onChange = (e) => {
    this.props.onChange(e);
  };
  onAddressChange = (e) => {
    this.props.onAddressChange(e);
  };
  onCityChange = (e) => {
    this.props.onCityChange(e);
  };
  cityEnterKeyEvent = (e) => {
    this.props.cityEnterKeyEvent(e);
  };
  displayAutoCompleteCityList = () => {
    this.props.displayAutoCompleteCityList();
  };

  onStateChange = (e) => {
    this.props.onStateChange(e);
  };
  stateEnterKeyEvent = (e) => {
    this.props.stateEnterKeyEvent(e);
  };
  displayAutoCompleteStateList = () => {
    this.props.displayAutoCompleteStateList();
  };

  onCountryChange = (e) => {
    this.props.onCountryChange(e);
  };
  countryCodeEnterKeyEvent = (e) => {
    this.props.countryCodeEnterKeyEvent(e);
  };
  displayAutoCompleteCountryCodeList = () => {
    this.props.displayAutoCompleteCountryCodeList();
  };

  render() {
    let shipToData = this.props.shipToData;
    let addressData = this.props.addressData;
    let isDisableFields = this.props.isDisableFields;

    return (
      <div>
        <div>
          <Row>
            <Col sm="1">
              {" "}
              <FormLabel>Company Code</FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                name="companyCode"
                type="text"
                placeholder="Enter CompanyCode"
                onChange={this.onChange}
                value={shipToData.companyCode}
                disabled={true}
              />{" "}
            </Col>
            <Col sm="1">
              {" "}
              <FormLabel>ShipTo</FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                ref={this.codeRef}
                name="code"
                type="text"
                placeholder="Enter ShipToCode"
                onChange={this.onChange}
                value={shipToData.code}
                style={{ "text-transform": "uppercase" }}
                disabled={isDisableFields}
                isMandatory={true}
              />{" "}
            </Col>
            <Col sm="1">
              <FormLabel>ShipTo Name</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="description"
                type="text"
                placeholder="Enter Name"
                onChange={this.onChange}
                value={shipToData.description}
                style={{ "text-transform": "capitalize" }}
                isMandatory={true}
              />
            </Col>
            <Col sm="1">
              <FormLabel>Type</FormLabel>
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                onChange={this.props.onShipToTypeChange}
                name="shipToType"
                placeholder="shipToType"
                value={shipToData.shipToType}
                lookupRequired={true}
                lookupHandler={this.props.shipToTypeLookupHandler}
                enterKeyEventHandler={this.props.shipToTypeEnterKeyEvent}
                autoCompleteListData={
                  this.props.shipToTypePageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={this.props.displayAutoCompleteShipToTypeList}
                showAutoCompleteList={this.props.showAutoCompleteShipToTypeList}
              />
            </Col>

          </Row>
          <Row>
            <Col sm="1">
              <FormLabel>Active</FormLabel>
            </Col>
            <Col sm="1">
              {" "}
              <InputCheckbox
                type="checkbox"
                name="isActive"
                onChange={this.onChange}
                checked={shipToData.isActive}
              />
            </Col>
          </Row>

          <br />
        </div>
        <div>
          <Row>
            <Col sm="2">
              <FormLabel className="address">Address</FormLabel>
            </Col>
          </Row>
          <hr class="row_border"></hr>
          <Row>
            <Col sm="1">
              <FormLabel>Address1</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="address1"
                type="text"
                placeholder="Enter Address1"
                onChange={this.onAddressChange}
                value={addressData.address1}
                style={{ "text-transform": "capitalize" }}
              />
            </Col>
            <Col sm="1">
              <FormLabel>Country</FormLabel>
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                onChange={this.onCountryChange}
                name="country"
                placeholder="country"
                valuePropery="code"
                descriptionProperty="description"
                value={addressData.country}
                lookupRequired={true}
                lookupHandler={this.props.countryLookupHandler}
                enterKeyEventHandler={this.countryCodeEnterKeyEvent}
                autoCompleteListData={
                  this.props.countryCodePageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={
                  this.displayAutoCompleteCountryCodeList
                }
                showAutoCompleteList={
                  this.props.showAutoCompleteCountryCodeList
                }
              />
            </Col>
            <Col sm="1">
              <FormLabel>Phone#2</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="phone2"
                type="text"
                placeholder="Enter Phone2"
                onChange={this.onAddressChange}
                value={addressData.phone2}
                style={{ "text-transform": "capitalize" }}
              />
            </Col>
          </Row>
          <Row>
            <Col sm="1">
              <FormLabel>Address2</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="address2"
                type="text"
                placeholder="Enter Address2"
                onChange={this.onAddressChange}
                value={addressData.address2}
                style={{ "text-transform": "capitalize" }}
              />
            </Col>
            <Col sm="1">
              <FormLabel>Zip</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="zip"
                type="text"
                placeholder="Enter Zip"
                onChange={this.onAddressChange}
                value={addressData.zip}
                style={{ "text-transform": "capitalize" }}
              />
            </Col>
            <Col sm="1">
              <FormLabel>Mobile#</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="mobilePhone"
                type="text"
                placeholder="Enter MobileNo"
                onChange={this.onAddressChange}
                value={addressData.mobilePhone}
                style={{ "text-transform": "capitalize" }}
              />
            </Col>
          </Row>
          <Row>
            <Col sm="1">
              <FormLabel>City</FormLabel>
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                onChange={this.onCityChange}
                name="city"
                placeholder="city"
                value={addressData.city}
                lookupRequired={true}
                lookupHandler={this.props.cityLookupHandler}
                enterKeyEventHandler={this.cityEnterKeyEvent}
                autoCompleteListData={
                  this.props.cityPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={this.displayAutoCompleteCityList}
                showAutoCompleteList={this.props.showAutoCompleteCityList}
              />
            </Col>
            <Col sm="1">
              <FormLabel>Contact Person</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="contactPerson"
                type="text"
                placeholder="ContactPerson"
                onChange={this.onAddressChange}
                value={addressData.contactPerson}
                style={{ "text-transform": "capitalize" }}
              />
            </Col>
            <Col sm="1">
              <FormLabel>Email</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="email"
                type="text"
                placeholder="Enter Email"
                onChange={this.onAddressChange}
                value={addressData.email}
                style={{ "text-transform": "capitalize" }}
              />
            </Col>
          </Row>
          <Row>
            <Col sm="1">
              <FormLabel>State</FormLabel>
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                onChange={this.onStateChange}
                name="state"
                placeholder="state"
                value={addressData.state}
                lookupRequired={true}
                lookupHandler={this.props.stateLookupHandler}
                enterKeyEventHandler={this.stateEnterKeyEvent}
                autoCompleteListData={
                  this.props.statePageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={this.displayAutoCompleteStateList}
                showAutoCompleteList={this.props.showAutoCompleteStateList}
              />
            </Col>
            <Col sm="1">
              <FormLabel>Phone#1</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="phone1"
                type="text"
                placeholder="Enter PhoneNo1"
                onChange={this.onAddressChange}
                value={addressData.phone1}
                style={{ "text-transform": "capitalize" }}
              />
            </Col>
            <Col sm="1">
              <FormLabel>Website</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="website"
                type="text"
                placeholder="Enter Website"
                onChange={this.onAddressChange}
                value={addressData.website}
                style={{ "text-transform": "capitalize" }}
              />
            </Col>
          </Row>

          <br />
        </div>
      </div>
    );
  }
}

class ShipToList extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      shipTo_list: [],
      response: {},
      pageTitle: "ShipTo",
      shipToData: new ShipToBean(),
      pageList: new PageListBean(),
      criteria: new ShipToSearchCriteria(),
      addressData: new AddressBean(),
      countries: [],
      cities: [],
      states: [],
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: false,
      isShowBackButton: false,
      error_list: [],
      totalCount: 0,
      isShipToListFormOpen: true,
      isShipToEntryFormOpen: false,
      isShowNodes: false,
      selectedNode: "headerView",
      alertMessage: [],
      alertType: "",
      isShowAlert: false,
      isShowExitButton: true,
      isPageListToolBar: true,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      isDisableFields: false,
      countryLookupHandler: null,
      showAutoCompleteCountryCodeList: true,
      countryCodePageListForAutoCompleteList: new Array(),
      cityLookupHandler: null,
      showAutoCompleteCityList: true,
      cityPageListForAutoCompleteList: new Array(),
      stateLookupHandler: null,
      showAutoCompleteStateList: true,
      statePageListForAutoCompleteList: new Array(),
      order: "asc",
      sortField: "",

      showAutoCompleteShipToTypeList: true,
      shipToTypePageListForAutoCompleteList: new Array(),

      shipToTypeLookupHandler: null,

      shipToTypeList: [],
    };
  }

  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    const { cache } = appData;
    this.cache = cache;
    let shipToData = new ShipToBean();
    shipToData.companyCode = this.companyCode;
    this.setState({ shipToData: shipToData });
    this.loadAttributeCache();
    this.loadPage(1);
    this.cleardata();
    //this.initLookupHandlers();
  }

  moduleCaption = "ShipTo";
  loadAttributeCache = () => {
    const attribute_cache = { ...this.cache };

    const countries = [];
    if (!isEmptyArray(attribute_cache.countries)) {
      countries.push(...attribute_cache.countries);
    }
    // this.state.countries = countries;
    const states = [];
    if (!isEmptyArray(attribute_cache.states)) {
      states.push(...attribute_cache.states);
    }

    // this.state.states = states;
    const cities = [];
    if (!isEmptyArray(attribute_cache.cities)) {
      cities.push(...attribute_cache.cities);
    }


    const shipToTypeList = [];
    if (!isEmptyArray(attribute_cache.shipToTypes)) {
      shipToTypeList.push(...attribute_cache.shipToTypes);
    }
    // this.state.cities = cities;
    // let shipToTypeList = [{ code: "Customer", name: "shipToType" }, { code: "General", name: "shipToType" }]
    this.setState({ countries: countries, states: states, cities: cities, shipToTypeList: shipToTypeList }, () => {
      this.initLookupHandlers();
    });
  };

  initLookupHandlers = () => {
    let cityLookupHandler = new GenericAttributeLookupHandler(
      this.state.cities,
      "City"
    );
    this.setState({ cityLookupHandler: cityLookupHandler });
    let stateLookupHandler = new GenericAttributeLookupHandler(
      this.state.states,
      "State"
    );
    this.setState({ stateLookupHandler: stateLookupHandler });

    let countryLookupHandler = new GenericAttributeLookupHandler(
      this.state.countries,
      "Country"
    );
    this.setState({ countryLookupHandler: countryLookupHandler });


    let shipToTypeLookupHandler = new GenericAttributeLookupHandler(
      this.state.shipToTypeList,
      "ShipToType"
    );
    this.setState({ shipToTypeLookupHandler: shipToTypeLookupHandler });
  };
  filterOnChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({
      criteria: criteria,
    });
  };
  cleardata = () => {
    let shipToData = new ShipToBean();
    shipToData.companyCode = this.companyCode;
    let addressData = new AddressBean();
    addressData.companyCode = this.companyCode;
    this.setState({
      shipToData: shipToData,
      addressData: addressData,
    });
  };
  saveShipToResponse = (response) => {
    this.handleresponse(response.data);
    this.loadPage(1);
    this.cleardata();
    this.closeShipToEntryForm();
  };

  saveShipTo = () => {
    let shipToData = this.state.shipToData;
    let addressData = this.state.addressData;
    shipToData.address = addressData;
    if (shipToData.isFetched == true) {
      if (SecurityAccessManager.ShipToMaintenanceEdit_IsAccessible()) {
        MasterService.updateShipTo(
          shipToData,
          this.saveShipToResponse,
          this.errorCallBack
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    } else {
      if (SecurityAccessManager.ShipToMaintenanceCreate_IsAccessible()) {
        MasterService.createShipTo(
          shipToData,
          this.saveShipToResponse,
          this.errorCallBack
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };

  editShipToResponse = (response) => {
    let shipToData = this.state.shipToData;
    let addressData = this.state.addressData;
    if (response.data != null) {
      if (response.data.shipToBean != null) {
        shipToData = response.data.shipToBean;
        if (shipToData.address != null) {
          addressData = shipToData.address;
          // this.setState({
          //   addressData: shipToData.address,
          // });
        }

        this.disable();
      }

    }
    this.setState({
      shipToData: shipToData,
      addressData:addressData
    },()=>{
      this.openShipToEntryForm();
    });
    
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };
  enterKeyEventHandler = (e) => {
    e.preventDefault();
    setTimeout(() => {
      this.opentypeforms();
    }, 200);
  };
  opentypeforms = () => {
    let shipToData = this.state.shipToData;
    this.editShipTo(shipToData.code);
  };
  editShipTo = (code) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = code;
    if (SecurityAccessManager.ShipToMaintenanceView_IsAccessible()) {
      MasterService.readShipTo(
        readrestInput,
        this.editShipToResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };

  onChange = (e) => {
    let shipToData = this.state.shipToData;
    shipToData[e.target.name] = e.target.value;
    this.setState({ shipToData: shipToData });
  };
  onAddressChange = (e) => {
    let addressData = this.state.addressData;
    addressData[e.target.name] = e.target.value;
    this.setState({ addressData: addressData });
  };
  handleresponse = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }

    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  save = () => {
    this.saveShipTo();
  };

  back = () => {
    this.clearError();
    this.cleardata();
    this.hideAlertCallBack(false);
    this.closeShipToEntryForm();
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };

  openShipToEntryForm = () => {
    let shipToData = this.state.shipToData;
    if (!shipToData.isFetched) {
      shipToData.shipToType = "GENERAL";
    }

    this.setState({
      isShipToListFormOpen: false,
      isShipToEntryFormOpen: true,
      isShowSaveButton: true,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: true,
      isShowBackButton: true,
      isShowNodes: false,
      isPageListToolBar: false,
      isLoadFirstButton: false,
      isLoadLastButton: false,
      isLoadPreviousButton: false,
      isLoadNextButton: false,
      shipToData: shipToData,
    });
    this.hideAlertCallBack();
  };

  closeShipToEntryForm = () => {
    this.clearError();
    let pageTitle = this.moduleCaption;
    this.setState({
      isShipToListFormOpen: true,
      isShipToEntryFormOpen: false,
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowBackButton: false,
      isShowClearErrorButton: false,
      pageTitle: pageTitle,
      isShowNodes: false,
      isPageListToolBar: true,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      isDisableFields: false,
    });
  };

  moduleExit = () => {
    this.props.onModuleExit();
  };
  loadShipToResponse = (response) => {
    if (response.data != null && response.data.shipToPageList != null) {
      let shipTos = new Array();
      if (!isEmptyArray(response.data.shipToPageList.shipTos)) {
        shipTos = response.data.shipToPageList.shipTos;
        // shipTos.map((Info) => {
        //   if (Info.isActive == true) {
        //     Info.isActive = "True";
        //   } else {
        //     Info.isActive = "False";
        //   }
        // });
      }
      let pageList = this.state.pageList;
      pageList.totalCount = response.data.shipToPageList.totalCount;
      pageList.currentPage = response.data.shipToPageList.currentPage;
      pageList.pageSize = response.data.shipToPageList.pageSize;
      this.setState({
        shipTo_list: shipTos,
        pageList: pageList,
      });
    }
  };
  loadFirst = () => {
    this.loadPage(1);
  };
  loadPrevious = () => {
    let currentPage = this.state.pageList.currentPage;
    let previousPage = currentPage - 1;
    this.loadPage(previousPage);
  };
  loadNext = () => {
    let currentPage = this.state.pageList.currentPage;
    let nextPage = currentPage + 1;
    this.loadPage(nextPage);
  };

  loadLast = () => {
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    let totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    this.loadPage(totalPages);
  };

  loadPage = (pageNumber) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    let pageList = this.state.pageList;
    let pageInput = new PageListBean();
    pageInput.pageSize = 50;
    pageInput.currentPage = pageNumber;
    if (pageList != null) pageInput.totalCount = pageList.totalCount;
    this.state.pageList = pageInput;
    this.loadShipToPage(pageInput, criteria);
  };
  loadShipToPage = (pageList, criteria) => {
    let requestInput = new RestShipToListRequest();
    requestInput.pageInput = pageList;
    requestInput.searchCriteria = criteria;
    this.state.pageList = pageList;
    if (SecurityAccessManager.ShipToMaintenanceView_IsAccessible()) {
      MasterService.getShipToPageList(
        requestInput,
        this.loadShipToResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };

  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  errorCallBack = (error) => {
    ShowError("Error : " + error);
  };
  onCountryChange = (e) => {
    let country = e.target.value;
    this.state.showAutoCompleteCountryCodeList = true;
    let addressData = this.state.addressData;
    let showAutoCompleteList = this.state.showAutoCompleteCountryCodeList;
    if (isEmpty(country)) {
      this.state.showAutoCompleteCountryCodeList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCountryCodeList;
      let addressData = this.state.addressData;
      addressData.country = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        addressData: addressData,
        countryCodePageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && country !== "") {
      this.readcountryCodeBySearchString(country);
    }
    if (e.target.name == "country") {
      addressData["country"] = e.target.value;
      let country_List = this.state.countries;
      country_List.map((country) => {
        if (country.code == e.target.value) {
          addressData["country"] = country.code;

          this.state.showAutoCompleteCountryCodeList = false;
          let showAutoCompleteList = this.state.showAutoCompleteCountryCodeList;
          this.setState({ showAutoCompleteList: showAutoCompleteList });
        }
      });
    }
    this.setState({ addressData: addressData });
  };
  readcountryCodeBySearchString(searchString) {
    let countryData = this.state.countries;
    let simpleAutoCompleteList = new Array();
    if (countryData.length > 0 && countryData != null) {
      countryData.map((countryDatas) => {
        let simpleItemBean = {
          code: countryDatas.code,
          description: countryDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;

    let filteredSuggestions = new Array();

    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletecountryLists) =>
        simpleAutoCompletecountryLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      countryCodePageListForAutoCompleteList: filteredSuggestions,
    });
  }
  countryCodeEnterKeyEvent = (e) => {
    let addressData = this.state.addressData;
    let country = e.target.value;

    addressData["country"] = e.target.value;
    let country_List = this.state.countries;
    let countryBean = null;
    country_List.map((country) => {
      if (country.code == e.target.value) {
        countryBean = country;
      }
    });
    if (!isEmpty(countryBean)) {
      let addressData = this.state.addressData;
      addressData.country = countryBean.code;

      this.setState({
        addressData: addressData,
        countryCodePageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteCountryCodeList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteCountryCodeList: showAutoCompleteList });
  };

  onCityChange = (e) => {
    let city = e.target.value;
    this.state.showAutoCompleteCityList = true;
    let temp_addressData = this.state.addressData;
    let showAutoCompleteList = this.state.showAutoCompleteCityList;
    if (isEmpty(city)) {
      this.state.showAutoCompleteCityList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCityList;
      let temp_addressData = this.state.addressData;
      temp_addressData.city = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        addressData: temp_addressData,
        cityPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && city !== "") {
      this.readcityBySearchString(city);
    }
    if (e.target.name == "city") {
      temp_addressData["city"] = e.target.value;
      let city_List = this.state.cities;
      city_List.map((city) => {
        if (city.code == e.target.value) {
          temp_addressData["city"] = city.code;

          this.state.showAutoCompleteCityList = false;
          let showAutoCompleteList = this.state.showAutoCompleteCityList;
          this.setState({ showAutoCompleteList: showAutoCompleteList });
        }
      });
    }
    this.setState({ addressData: temp_addressData });
  };
  readcityBySearchString(searchString) {
    let cityData = this.state.cities;
    let simpleAutoCompleteList = new Array();
    if (cityData.length > 0 && cityData != null) {
      cityData.map((cityDatas) => {
        let simpleItemBean = {
          code: cityDatas.code,
          description: cityDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletecityLists) =>
        simpleAutoCompletecityLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({ cityPageListForAutoCompleteList: filteredSuggestions });
  }
  cityEnterKeyEvent = (e) => {
    let temp_addressData = this.state.addressData;
    temp_addressData["city"] = e.target.value;
    let city_List = this.state.cities;
    let cityBean = null;
    city_List.map((city) => {
      if (city.code == e.target.value) {
        cityBean = city;
      }
    });
    if (!isEmpty(cityBean)) {
      let temp_addressData = this.state.addressData;
      temp_addressData.city = cityBean.code;
      this.setState({
        addressData: temp_addressData,
        cityPageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteCityList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteCityList: showAutoCompleteList });
  };

  onStateChange = (e) => {
    let state = e.target.value;
    this.state.showAutoCompleteStateList = true;
    let temp_addressData = this.state.addressData;
    let showAutoCompleteList = this.state.showAutoCompleteStateList;
    if (isEmpty(state)) {
      this.state.showAutoCompleteStateList = false;
      let showAutoCompleteList = this.state.showAutoCompleteStateList;
      let temp_addressData = this.state.addressData;
      temp_addressData.state = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        addressData: temp_addressData,
        statePageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && state !== "") {
      this.readstateBySearchString(state);
    }
    if (e.target.name == "state") {
      temp_addressData["state"] = e.target.value;
      let state_List = this.state.states;
      state_List.map((state) => {
        if (state.code == e.target.value) {
          temp_addressData["state"] = state.code;
          this.state.showAutoCompleteStateList = false;
          let showAutoCompleteList = this.state.showAutoCompleteStateList;
          this.setState({ showAutoCompleteList: showAutoCompleteList });
        }
      });
    }
    this.setState({ addressData: temp_addressData });
  };
  readstateBySearchString(searchString) {
    let stateData = this.state.states;
    let simpleAutoCompleteList = new Array();
    if (stateData.length > 0 && stateData != null) {
      stateData.map((stateDatas) => {
        let simpleItemBean = {
          code: stateDatas.code,
          description: stateDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletestateLists) =>
        simpleAutoCompletestateLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({ statePageListForAutoCompleteList: filteredSuggestions });
  }
  stateEnterKeyEvent = (e) => {
    let temp_addressData = this.state.addressData;
    temp_addressData["state"] = e.target.value;
    let state_List = this.state.states;
    let stateBean = null;
    state_List.map((state) => {
      if (state.code == e.target.value) {
        stateBean = state;
      }
    });
    if (!isEmpty(stateBean)) {
      let temp_addressData = this.state.addressData;
      temp_addressData.state = stateBean.code;
      this.setState({
        addressData: temp_addressData,
        statePageListForAutoCompleteList: new Array(),
      });
    }
  };

  displayAutoCompleteStateList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteStateList: showAutoCompleteList });
  };
  handleSortingChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSorting(sortField, sortOrder);
  };
  handleSorting = (sortField, sortOrder) => {
    let list = this.state.shipTo_list;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ shipTo_list: sorted });
    }
  };





  onShipToTypeChange = (e) => {
    let shipToType = e.target.value;
    this.state.showAutoCompleteShipToTypeList = true;
    let temp_Ship_To_Data = this.state.shipToData;
    let showAutoCompleteList = this.state.showAutoCompleteShipToTypeList;
    if (isEmpty(shipToType)) {
      this.state.showAutoCompleteShipToTypeList = false;
      let showAutoCompleteList = this.state.showAutoCompleteShipToTypeList;
      let temp_Ship_To_Data = this.state.shipToData;
      temp_Ship_To_Data.shipToType = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        shipToData: temp_Ship_To_Data,
        shipToTypePageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && shipToType !== "") {
      this.readShipToTypeBySearchString(shipToType);
    }
    if (e.target.name == "shipToType") {
      temp_Ship_To_Data["shipToType"] = e.target.value;
      let shipToType_List = this.state.shipToTypeList;
      shipToType_List.map((shipToType) => {
        if (shipToType.code == e.target.value) {
          temp_Ship_To_Data["shipToType"] = shipToType.code;

          this.state.showAutoCompleteShipToTypeList = false;
          let showAutoCompleteList = this.state.showAutoCompleteShipToTypeList;
          this.setState({ showAutoCompleteList: showAutoCompleteList });
        }
      });
    }
    this.setState({ shipToData: temp_Ship_To_Data });
  };
  readShipToTypeBySearchString(searchString) {
    let shipToTypeData = this.state.shipToTypeList;
    let simpleAutoCompleteList = new Array();
    if (shipToTypeData.length > 0 && shipToTypeData != null) {
      shipToTypeData.map((shipToTypeDatas) => {
        let simpleItemBean = {
          code: shipToTypeDatas.code,
          description: shipToTypeDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteshipToTypeLists) =>
        simpleAutoCompleteshipToTypeLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({ shipToTypePageListForAutoCompleteList: filteredSuggestions });
  }
  shipToTypeEnterKeyEvent = (e) => {
    let temp_Ship_To_Data = this.state.shipToData;
    temp_Ship_To_Data["shipToType"] = e.target.value;
    let shipToType_List = this.state.shipToTypeList;
    let shipToTypeBean = null;
    shipToType_List.map((shipToType) => {
      if (shipToType.code == e.target.value) {
        shipToTypeBean = shipToType;
      }
    });
    if (!isEmpty(shipToTypeBean)) {
      let temp_Ship_To_Data = this.state.shipToData;
      temp_Ship_To_Data.shipToType = shipToTypeBean.code;
      this.setState({
        shipToData: temp_Ship_To_Data,
        shipToTypePageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteShipToTypeList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteShipToTypeList: showAutoCompleteList });
  };
  filterShipToType = () => {

    this.loadPage(1);

  };
  resetShiptToType = () => {
    let criteria = new ShipToSearchCriteria();
    this.setState({ criteria: criteria }, () => {
      this.loadPage(1);
    });
  }

  render() {
    let pageList = this.state.pageList;
    let totalPages = 0;
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    let currentPage = pageList.currentPage;
    return (
      <div>
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />

        {this.state.isPageListToolBar && (
          <BaseInquiryPageListToolBar
            currentPage={currentPage}
            totalPages={totalPages}
            isLoadFirstButton={this.state.isLoadFirstButton}
            isLoadLastButton={this.state.isLoadLastButton}
            isLoadPreviousButton={this.state.isLoadPreviousButton}
            isLoadNextButton={this.state.isLoadNextButton}
            loadFirst={this.loadFirst}
            loadLast={this.loadLast}
            loadNext={this.loadNext}
            loadPrevious={this.loadPrevious}
          />
        )}
        {this.state.isShipToListFormOpen && (
          <BaseInquiryToolBar
            onModuleExit={() => this.moduleExit()}
            pageTitle={this.state.pageTitle}
            isShowExitButton={this.state.isShowExitButton}
          />
        )}

        {!this.state.isShipToListFormOpen && (
          <BaseToolBar
            back={this.back}
            save={this.save}
            clearError={this.clearError}
            isShowSaveButton={this.state.isShowSaveButton}
            isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
            isShowClearErrorButton={this.state.isShowClearErrorButton}
            isShowBackButton={this.state.isShowBackButton}
            pageTitle={this.state.pageTitle}
          />
        )}
        {this.state.isShipToListFormOpen && (
          <ShipToListForm
            {...this.state}
            onChange={this.onChange}
            editShipTo={this.editShipTo}
            enterKeyEventHandler={this.enterKeyEventHandler}
            opentypeforms={this.opentypeforms}
            handleSortingChange={this.handleSortingChange}

            filterOnChange={this.filterOnChange}
            filterShipToType={this.filterShipToType}
            resetShiptToType={this.resetShiptToType}
          />
        )}

        {this.state.isShipToEntryFormOpen && (
          <ShipToEntryForm
            {...this.state}
            onChange={this.onChange}
            onAddressChange={this.onAddressChange}
            onCountryChange={this.onCountryChange}
            countryCodeEnterKeyEvent={this.countryCodeEnterKeyEvent}
            displayAutoCompleteCountryCodeList={
              this.displayAutoCompleteCountryCodeList
            }
            onCityChange={this.onCityChange}
            cityEnterKeyEvent={this.cityEnterKeyEvent}
            displayAutoCompleteCityList={this.displayAutoCompleteCityList}
            onStateChange={this.onStateChange}
            stateEnterKeyEvent={this.stateEnterKeyEvent}
            displayAutoCompleteStateList={this.displayAutoCompleteStateList}


            onShipToTypeChange={this.onShipToTypeChange}
            shipToTypeEnterKeyEvent={this.shipToTypeEnterKeyEvent}
            displayAutoCompleteShipToTypeList={this.displayAutoCompleteShipToTypeList}
          />
        )}
      </div>
    );
  }
}

function ShipToAttributeModule(props) {
  return (
    <div id="moduleContainer" className="module_container">
      <div className="app">
        <ShipToList {...props} name="" />
        <br />
      </div>
    </div>
  );
}
export default ShipToAttributeModule;
